// @flow
import * as React from 'react';

import { ASC, DSC } from './calendar.consts.js';

export default function SortingArrows({ field, onClick, sortingField, sortingDirection }) {
  return (
    <div className="sort-arrows-wrap">
      <div className="sort-arrows">
        <span
          className={sortingField === field && sortingDirection === ASC ? 'active' : 'inactive'}
          data-direction={ASC}
          data-field={field}
          onClick={onClick}
        >
          <i className="icon arrow-up" />
        </span>
        <span
          className={sortingField === field && sortingDirection === DSC ? 'active' : 'inactive'}
          data-direction={DSC}
          data-field={field}
          onClick={onClick}
        >
          <i className="icon arrow" />
        </span>
      </div>
    </div>
  );
}
